import React from 'react';

interface SectionHeadingProps {
  children: React.ReactNode;
  className?: string;
}

export const SectionHeading: React.FC<SectionHeadingProps> = ({ children, className = '' }) => {
  return (
    <h3
      className={`text-sm font-semibold text-gray-500 uppercase tracking-wide ${className}`}
    >
      {children}
    </h3>
  );
};
